<template>
  <div class="gallery-section__slide">
    <div class="gallery-section-title--container">
        <p v-text="slide.subtitle" class="subtitle" />
        <button v-if="hasWidgetId" @click="exploreTheProjectModalOpen(slide)" class="gallery-section--button-explore"><img alt="Explore the project" src="@/assets/img/gallery/en/vector.svg" />{{ translations[lang].button_explore }}</button>
      </div>

    <div class="gallery-section__slide-img-wrapper">
      <img :src="require('@/assets/img/gallery/' + lang + '/gallery-slide-' + index + '-1.'+ getResolution())" alt="avatar" />
      <img :src="require('@/assets/img/gallery/'+ lang + '/gallery-slide-' + index + '-2.'+ getResolution())" alt="avatar" />
    </div>
  </div>

  <ExploreTheProjectModal :is-open="isExploreTheProjectModalOpen" @close="closeExploreTheProjectModal" :selected-subtitle="selectedSubtitle"></ExploreTheProjectModal>
</template>

<script setup>
import { ref, computed } from 'vue';
import ExploreTheProjectModal from '@/Components/En/Modals/ExploreTheProjectModal.vue';
import { widgetGalleryPlansIds } from '@/enums/widgetGalleryPlansIds';

const props = defineProps({
  slide: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  lang: {
    type: String,
    default: 'en',
  },
});

const isExploreTheProjectModalOpen = ref(false);
const selectedSubtitle = ref('');

const translations = ref({
  en: {
    button_explore: 'Explore the project',
  },
  ru: {
    button_explore: 'Посмотреть проект',
  },
});

const getResolution = () => (props.lang === 'en' ? 'png' : 'webp');

const exploreTheProjectModalOpen = (slide) => {
  const { subtitle } = slide;
  const widgetId = widgetGalleryPlansIds[subtitle];

  if (!widgetId) {
    console.warn(`Нет виджета для subtitle: ${subtitle}`);
    return;
  }

  selectedSubtitle.value = subtitle;
  isExploreTheProjectModalOpen.value = true;
};

const closeExploreTheProjectModal = () => {
  isExploreTheProjectModalOpen.value = false;
};

const hasWidgetId = computed(() => !!widgetGalleryPlansIds[props.slide.subtitle]);

</script>
